import '../helpers/functions';
import Popup from "../helpers/Popup";

$(document).ready(function () {
    const page = {};
    page.text = $('.advantage-info');
    page.btn = '<div class="advantage--expand link link--border link--light"><span>Подробнее</span><span style="display: none;">Скрыть</span></div>';
    page.maxHeight = 100;
    page.popup = "#base"

    const action = {};
    action.setDefaults = function(){
        page.text.each(function () {
            if ($(this).innerHeight() > page.maxHeight) {
                $(this).attr('data-height', $(this).innerHeight());
                $(this).css('height', page.maxHeight).addClass('cutted');
                action.addButton($(this));
            }
        })
    };

    action.onClick = function (e, btn) {
        e.preventDefault();
        e.stopPropagation();
        const html = btn.parent().find('.to-expand').html();
        $(page.popup).find('.text-popup-content').html(html);
        Popup.get(page.popup).show($(this));
    };

    action.addButton = function(el) {
        $(page.btn).insertAfter(el);
    };

    action.setDefaults();
    $(page.popup).find('.close').click(function () {
       $(this).parents('.text-popup').find('.text-popup-content').html('');
        Popup.get(page.popup).hide();
    });

    $(document).on('click', '.advantage--expand', function (e) {
        action.onClick(e, $(this));
    });
});